import React, { useState } from 'react'
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import { ChevronsRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Admin = () => {

    const [sidebarOpen, setSidebarOpen] = useState(false);
    const { signinData } = useSelector((state) => (state.auth))

    return (

        <div className="flex dark:bg-dark font-primary  h-screen overflow-hidden bg-[#fafafa]">
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main>
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                        <div className='grid md:grid-cols-3 grid-cols-2 gap-10'>
                            {signinData?.role === 'Admin' && (
                                <>
                                    <Link to='/success-stories' class="rounded-xl shadow-md p-6 bg-brand_50">
                                        <div class="font-semibold mb-1 md:text-lg text-md text-white" >Success</div>
                                        <div className='flex justify-between items-center'>
                                            <div class="font-semibold md:text-5xl text-4xl tracking-tight text-[#f5f5f5]" >Stories</div>
                                            <ChevronsRight size={40} className='stroke-white' />
                                        </div>
                                    </Link>
                                    <Link to='/premium-course/draft' class="rounded-xl shadow-md p-6 bg-brand_50">
                                        <div class="font-semibold mb-1 md:text-lg text-md text-white" >Premium</div>
                                        <div className='flex justify-between items-center'>
                                            <div class="font-semibold md:text-5xl text-4xl tracking-tight text-[#f5f5f5]" >Course</div>
                                            <ChevronsRight size={40} className='stroke-white' />
                                        </div>
                                    </Link>

                                </>
                            )}
                            <Link to='/problem-setter/draft' class="rounded-xl shadow-md p-6 bg-brand_50">
                                <div class="font-semibold mb-1 md:text-lg text-md text-white" >Problem</div>
                                <div className='flex justify-between items-center'>
                                    <div class="font-semibold md:text-5xl text-4xl tracking-tight text-[#f5f5f5]" >Setter</div>
                                    <ChevronsRight size={40} className='stroke-white' />
                                </div>
                            </Link>
                            <Link to='/write/draft' class="rounded-xl shadow-md p-6 bg-brand_50">
                                <div class="font-semibold mb-1 md:text-lg text-md text-white" >Write</div>
                                <div className='flex justify-between items-center'>
                                    <div class="font-semibold md:text-5xl text-4xl tracking-tight text-[#f5f5f5]" >Blogs</div>
                                    <ChevronsRight size={40} className='stroke-white' />
                                </div>
                            </Link>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    )
}

export default Admin